import React from 'react';

let Visuales = (props) => {
  let {vis, approved, selected} = props;
  if (approved) {
    let visuals = Object.keys(vis).map((key, index) => {
      let id = parseInt(vis[key].id, 10);
      return (
        approved.map((appid, i) => {
          if (appid === id){
            if(appid === parseInt(selected.id)){
              return (<button type="reset"
              value={vis[key].id}
              className="visual white selected"
              key={vis[key].id} 
              onClick={props.selectVis(vis)}
              >{vis[key].abr}</button>)
            } else {
              return (<button type="reset"
              value={vis[key].id}
              className="visual white"
              key={vis[key].id} 
              onClick={props.selectVis(vis)}
              >{vis[key].abr}</button>)
            }
          } else {
            return null;
          }
        })
      )
    });
    
    return visuals;
  }
  return <div>Selecciona un tablero</div>
  
}
export default Visuales;


// WEBPACK FOOTER //
// ./src/Components/AddCards/Visuales.js